module.exports = __webpack_public_path__ + "static/media/insta.756e4542.png";